import { render } from "./CompanyRoyalties.vue?vue&type=template&id=4557a337&scoped=true"
import script from "./CompanyRoyalties.vue?vue&type=script&lang=js"
export * from "./CompanyRoyalties.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\Ltd24ore-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4557a337"]])

export default __exports__